import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import MainLayout from './components/layout/MainLayout';
import ErrorBoundary from './components/common/ErrorBoundary';
import Home from './pages/Home/Home';
import Intelligence from './pages/Intelligence';
import Plans from './pages/Plans';
import CreativeServices from './pages/CreativeServices';
import RequestReview from './pages/RequestReview';
import AdminDashboard from './pages/Admin/Dashboard';
import Contact from './pages/Contact';
import Work from './pages/Work';
import About from './pages/About';
import Insights from './pages/Insights';
import Solutions from './pages/Solutions';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Cookies from './pages/Cookies';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import NotFound from './pages/NotFound';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <ScrollToTop />
        <Routes>
          {/* Admin Dashboard */}
          <Route path="/admin" element={<AdminDashboard />} />
          
          {/* Client Portal Dashboard */}
          <Route path="/dashboard" element={<Dashboard />} />
          
          {/* Main Website Pages */}
          <Route path="/" element={<MainLayout><Home /></MainLayout>} />
          <Route path="/intelligence" element={<MainLayout><Intelligence /></MainLayout>} />
          <Route path="/plans" element={<MainLayout><Plans /></MainLayout>} />
          <Route path="/creative-services" element={<MainLayout><CreativeServices /></MainLayout>} />
          <Route path="/solutions" element={<MainLayout><Solutions /></MainLayout>} />
          <Route path="/work" element={<MainLayout><Work /></MainLayout>} />
          <Route path="/about" element={<MainLayout><About /></MainLayout>} />
          <Route path="/insights" element={<MainLayout><Insights /></MainLayout>} />
          <Route path="/contact" element={<MainLayout><Contact /></MainLayout>} />
          <Route path="/request-review" element={<MainLayout><RequestReview /></MainLayout>} />
          <Route path="/login" element={<MainLayout><Login /></MainLayout>} />
          
          {/* Legal Pages */}
          <Route path="/privacy" element={<MainLayout><Privacy /></MainLayout>} />
          <Route path="/terms" element={<MainLayout><Terms /></MainLayout>} />
          <Route path="/cookies" element={<MainLayout><Cookies /></MainLayout>} />
          
          {/* 404 Fallback */}
          <Route path="*" element={<MainLayout><NotFound /></MainLayout>} />
        </Routes>
      </Router>
    </ErrorBoundary>
  );
}

export default App;